import conversations from './conversations'
import users from './users'
import plugins from './plugins'
import categories from './categories'
import suggestions from './suggestions'

export default {
  conversations,
  users,
  plugins,
  categories,
  suggestions
}
